const JourneyOutcome = {
  GOAL_ACHIEVED: 'GOAL_ACHIEVED',
  GOAL_UNMET: 'GOAL_UNMET',
  TIMEOUT: 'TIMEOUT',
};

export default JourneyOutcome;
